// gastosContext.js
import { createContext, useState, useContext } from "react";
import { crearGastoUseCase } from "../../../core/gastos/application/crearGasto.usecase.js";
import { listarGastosUseCase } from "../../../core/gastos/application/listarGastos.usecase.js";

export const GastosContext = createContext(null);

export function GastosProvider({ children }) {
  const [gastos, setGastos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Registrar gasto
  const registrarGasto = async (data) => {
    setLoading(true);
    setError(null);

    try {
      const gastoCreado = await crearGastoUseCase(data);

      setGastos((prev) => [...prev, gastoCreado]);

      return gastoCreado;
    } catch (e) {
      setError(e.message || "Error al registrar gasto");
      throw e;
    } finally {
      setLoading(false);
    }
  };

  //
  const listarGastos = async (filtros) => {
    setLoading(true);
    setError(null);

    try {
      const data = await listarGastosUseCase(filtros);
      setGastos(data);
      return data;
    } catch (e) {
      setError(e.message || "Error al listar gastos");
      throw e;
    } finally {
      setLoading(false);
    }
  };

  return (
    <GastosContext.Provider
      value={{
        gastos,
        loading,
        error,
        registrarGasto,
        listarGastos,
      }}
    >
      {children}
    </GastosContext.Provider>
  );
}


export function useGastos() {
  const context = useContext(GastosContext);
  if (!context) {
    throw new Error(" [useGastos]  debe usarse dentro de GastosProvider");
  }
  return context;
}